import { CountryFlagIcon } from './CountryFlagIcon'

export default CountryFlagIcon
